import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CSP_NONCE, Inject, Injectable } from "@angular/core";
import { ConfigService } from "./config.service";
import { EncriptionService, RequestCriticalLevel } from "digital-core";
import { HeaderMetaService } from 'common/services/header-meta.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
nonce: string | null;

  constructor(
    private httpsClient: HttpClient,
    private configService: ConfigService,
    private encryptionService: EncriptionService,
    private headerMetaService:HeaderMetaService,
     @Inject(CSP_NONCE) nonce: string | null
  ) { 
        this.nonce=nonce;
  }

  getConfig(): Promise<void> {
    let level: RequestCriticalLevel = RequestCriticalLevel.Default
    let httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }).set(level, 'true')
    };

    return new Promise((resolve, reject) => {

      this.httpsClient.get<any>(
        `${this.configService.apiUrl}api/v${this.configService.apiVersion}/resource/getClientConfig`,
        httpOptions
      ).subscribe({
        next: (configJson) => {
          if (configJson) {
            configJson.Keys.GoogleApiKey = this.getDecryptedValue(configJson, 'Keys.GoogleApiKey');
            configJson.GoogleAnalytics.gtmId = this.getDecryptedValue(configJson, 'GoogleAnalytics.gtmId');
            configJson.LegacyPayment.paymentUrl = this.getDecryptedValue(configJson, 'LegacyPayment.paymentUrl');
            configJson.LegacyPayment.originatorPrefix = this.getDecryptedValue(configJson, 'LegacyPayment.originatorPrefix');
            configJson.LegacyPayment.amount = this.getDecryptedValue(configJson, 'LegacyPayment.amount'); 
            configJson.LegacyPayment.secret = this.getDecryptedValue(configJson, 'LegacyPayment.secret'); 
            configJson.LegacyPayment.originatorNumber = this.getDecryptedValue(configJson, 'LegacyPayment.originatorNumber');
            configJson.OktaSettings.oktaPrefix = this.getDecryptedValue(configJson, 'OktaSettings.oktaPrefix'); 
            configJson.OktaSettings.oktaBaseUrl = this.getDecryptedValue(configJson, 'OktaSettings.oktaBaseUrl');
            configJson.OktaSettings.oktaClientId = this.getDecryptedValue(configJson, 'OktaSettings.oktaClientId');
            configJson.OktaSettings.oktaInternalEndPoint = this.getDecryptedValue(configJson, 'OktaSettings.oktaInternalEndPoint');
            configJson.OktaSettings.oktaIssuer = this.getDecryptedValue(configJson, 'OktaSettings.oktaIssuer'); 
            configJson.OktaSettings.oktaAuthIssuer = this.getDecryptedValue(configJson, 'OktaSettings.oktaAuthIssuer'); 
            configJson.OktaSettings.oktaAuthorizeUrl = this.getDecryptedValue(configJson, 'OktaSettings.oktaAuthorizeUrl');
            configJson.OktaSettings.redirectUrl = this.getDecryptedValue(configJson, 'OktaSettings.redirectUrl');
            configJson.AppInsights.instrumentationKey = this.getDecryptedValue(configJson, 'AppInsights.instrumentationKey');
            configJson.Core.aPIRequestEncryptionKey = this.getDecryptedValue(configJson, 'Core.aPIRequestEncryptionKey');
            configJson.Core.siteUrl = window['config'].site.isLocal == true ? window['config'].site.apiUrl + "api/v1/" : configJson.Core.siteUrl;
            window['config'].core = configJson.Core;
            window['config'].appInsights = configJson.AppInsights;
            window['config'].aul = window['config'].site.isLocal == true ? window['config'].aul : configJson.Aul;
            window['config'].googleAnalytics = configJson.GoogleAnalytics;
            window['config'].gpmPaymentgatewaySettings = configJson.GpmPaymentgatewaySettings;
            window['config'].keys = configJson.Keys;
            window['config'].legacyPayment = configJson.LegacyPayment;
            window['config'].oktaSettings = configJson.OktaSettings;
            window['config'].sitefinitySettings = configJson.SitefinitySettings;
            this.headerMetaService.updateMetaTags( this.nonce);
            this.callJsFuntions();
            resolve();
          }
        },
        error: (err) => {
          console.log('App Configuration failed to fetch', err);
          reject(err);
        }

      });

    });

  }
  getDecryptedValue(obj: any, propertyPath: string): string {
    const properties = propertyPath.split('.');
    let value = obj;
    for (const prop of properties) {
      if (value == null) {
        return '';
      }
      value = value[prop];
    }
    if (value == null || value === '') {
      return '';
    }
    try {
      const decrypted = this.encryptionService.dec(value);
      return decrypted === '' ? value : decrypted;
    } catch (decryptedError) {
      return value;
    }
  }

  callJsFuntions() {
    if (typeof window['changeFavicon'] === 'function') {
      window['changeFavicon']();
    }
    if (typeof window['getGoogleKey'] === 'function') {
      window['getGoogleKey']();
    }
    if (typeof window['googleAnalytics'] === 'function') {
      window['googleAnalytics']();
    }
  }


}
